<template>
	<div class="xs-12 p4">
		<core-form-input
			componentName="j-base-select"
			name="code"
			:options="options.exclusionsCodes"
			:label="$t('exclusion_code')"
			v-validate="'required'"
			v-model="form.code"
			:validationErrors="errors"
		/>

		<core-form-input
			class="mt6"
			componentName="j-base-input-long-text"
			name="remarks"
			:options="options.remarks"
			:label="$t('remarks')"
			v-model="form.remarks"
		/>

		<!-- Buttons -->
		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave">
				{{ $t("save") }}
			</j-button>
			<j-button @click="handleCancel" type="bordered">
				{{ $t("cancel") }}
			</j-button>
		</div>
	</div>
</template>

<script>
/**
 * This component is responsible for creation and update of exclusions
 * Exclusion can be added on offer or directly on policy
 * It's a smart component calling APIs
 *
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "@/api/gql.js"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		// policyId: {
		// 	type: String,
		// 	required: true,
		// 	default: ""
		// },

		caseId: {
			validator(val) {
				return typeof val === "string" || val === null
			},
			required: true
		},

		proposalId: {
			validator(val) {
				return typeof val === "string" || val === null
			},
			required: true
		},

		offerId: {
			validator(val) {
				return typeof val === "string" || val === null
			},
			required: true
		},

		/**
		 * This is important for settings, we get it from product.pricing
		 */
		productId: {
			type: Object,
			required: true,
			default: () => ({
				plan: null,
				type: null,
				version: null
			})
		}
	},
	data() {
		return {
			// When saving is in progress
			isLoading: false,

			// Form payload
			form: {
				code: null,
				remarks: null
			},

			// Options for select boxes
			options: {
				type: [
					{ name: this.$t("percentage"), value: "ratio" },
					{ name: this.$t("flat"), value: "flat" }
				],
				exclusionsCodes: []
			}
		}
	},

	methods: {
		async fetchExclusionsSettings() {
			try {
				const res = await this.exclusionsSettings({
					where: { productId: this.productId }
				})

				this.options.exclusionsCodes = res[0].exclusionSettings.codeNames.map(
					item => ({
						name: `${item.code} - ${item.name}`,
						value: item.code
					})
				)
			} catch (error) {
				console.log(error)
			}
		},

		async handleSave() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.isLoading = true
			try {
				await this.addExclusionToProposalOffer()
				this.$emit("created")
			} catch (error) {
				this.$store.dispatch("showError", error)
				console.log(error)
			}
			this.isLoading = false
		},

		handleCancel() {
			this.$emit("cancelled")
		},

		async exclusionsSettings(variables) {
			return new Promise(async (resolve, reject) => {
				const query = `
					query exclusionsSettings($where: productWhereInput){
						products_2(where:$where){
							list{
								exclusionSettings{
									codeNames{
										code
										name
									}
								}
							}
						}
					}
				`
				await this.APIRequest("products_2", query, variables, resolve, reject)
			})
		},

		addExclusionToProposalOffer() {
			return new Promise(async (resolve, reject) => {
				const query = `mutation addExclusionToProposalOffer (
					$caseId: String!,
					$proposalId: String!,
					$offerId: String!,
					$input: exclusionInput!
				) {
					addExclusionToProposalOffer (
						caseId: $caseId,
						proposalId: $proposalId,
						offerId: $offerId,
						input: $input
					) {
						createdStatus {
							id
						}
						errors
						status
					}
				}`

				const variables = {
					caseId: this.caseId,
					proposalId: this.proposalId,
					offerId: this.offerId,
					input: {
						offerId: this.offerId,
						code: this.form.code,
						remark: this.form.remarks
					}
				}
				await this.APIRequest(
					"addExclusionToProposalOffer",
					query,
					variables,
					resolve,
					reject
				)
			})
		},

		async APIRequest(type, query, variables, resolve, reject) {
			try {
				const { data, errors } = await api({
					query,
					variables
				})

				if (errors) {
					reject(errors)
				} else if (data.errors) {
					reject(data.errors)
				} else {
					resolve(data[type].createdStatus || data[type].list || data[type])
				}
			} catch (error) {
				reject(error)
			}
		}
	},

	created() {
		// Fetch exclusion settings
		this.fetchExclusionsSettings()
	}
}
</script>
